import { Construction } from 'lucide-react';
import { Link } from 'react-router-dom';

export const NotReadyYet = ({ title, message, ctaText = 'Torna alla Home', ctaLink = '/' }) => (
  <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="not-ready-yet">
    <div className="max-w-md w-full glass-card p-8 sm:p-10 text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 border border-gold/30 mb-4">
        <Construction className="w-8 h-8 text-gold" />
      </div>
      <h2 className="font-heading text-2xl sm:text-3xl font-bold mb-3">{title}</h2>
      <p className="text-slate-400 text-sm sm:text-base mb-6">{message}</p>
      <Link
        to={ctaLink}
        className="inline-block px-6 py-3 bg-primary text-slate-950 font-semibold rounded-lg hover:bg-primary/90 transition-colors"
        data-testid="not-ready-cta"
      >
        {ctaText}
      </Link>
    </div>
  </div>
);

export default NotReadyYet;
